import { Periodicity } from "@modules/completedSessions/completedSessionsType"
import { useServicesContext } from "@modules/core/services/services.context"
import { convertPublicProfileFromDto } from "@modules/profile/publicProfile/publicProfileDto"
import { useQuery } from "@tanstack/react-query"

export const useUserProfile = (id: string) => {
  const { publicUserApi } = useServicesContext()
  const { data, isLoading } = useQuery({
    queryKey: ["userProfile", id],
    queryFn: async () => {
      return await publicUserApi.getProfile(id)
    },
    enabled: id !== "",
  })

  return {
    data: data ? convertPublicProfileFromDto(data) : undefined,
    isLoading,
  }
}

export const useCompletedSessions = (id: string, periodicity: Periodicity, limit: number) => {
  const { publicProfileService } = useServicesContext()
  const { data, isLoading } = useQuery({
    queryKey: ["completedSessions", id, periodicity, limit],
    queryFn: () => publicProfileService.fetchCompletedSessions({ id, periodicity, limit }),
  })
  return { data, isLoading }
}
